import React, { useEffect, useState } from 'react';
import Auxiliary from '../../util/Auxiliary';
import Title from '../../components/Title/Title';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import axios from '../../util/Api';
import { Card, Col, Row, Statistic } from 'antd';
import Item from '../../components/Detail/Item';
import Date from '../../components/Formatter/Date';
import PassportProject from './PassportProject';
import { Link } from 'react-router-dom';

const Detail = (props) => {
  const [loading, setLoading] = useState(true);
  const [project, setProject] = useState({});
  const { id } = queryString.parse(useLocation().search);

  const fetchProject = () => {
    setLoading(true);
    const url = `/project/detail?id=${id}`;
    axios.get(url).then(resp => {
      setProject(resp.data);
      setLoading(false);
    }).catch(err => {
      
    });
  }

  useEffect(() => {
    fetchProject();
  }, []);

  return (
    <Auxiliary>
      <Title actions={(
        <Link to={`/project/update?id=${id}`} className="ant-btn">Perbarui Proyek</Link>
      )}>Detail Proyek</Title>
      {loading ? "Sedang memuat..." : <Content project={project} />}
    </Auxiliary>
  );
}

export default Detail;

const Content = ({ project }) => {
  return (
    <Row>
      <Col span={24}>
        <Card className="gx-card" title={`Detail Proyek ${project.name}`}>
          <Item label={`Kode Proyek`} value={project.code}/>
          <Item label={`Status`} value={project.status.label}/>
          <Item label={`Periode`} value={(
            <>
              <Date value={project.start_date}/> - <Date value={project.end_date}/>
            </>
          )}/>
          <Item label={`Divisi Proyek`} value={project.division.label}/>
          <Item label={`PM / Manajer Proyek`} value={(
            <div>
              <div>{project.manager}</div>
              <div className="gx-text-muted">{project.phone} / {project.email}</div>
            </div>
          )}/>
        </Card>
        <Row>
          <Col span={8}>
            <Card className="gx-card gx-p-15">
              <Statistic title="Personel Terdaftar" value={project.passport.count} />
            </Card>
          </Col>
          <Col span={8}>
            <Card className="gx-card gx-p-15">
              <Statistic title="Tap Summary" value={project.tap.summary} />
            </Card>
          </Col>
          <Col span={8}>
            <Card className="gx-card gx-p-15">
              <Statistic title="Total Tap" value={project.tap.count} />
            </Card>
          </Col>
        </Row>
        <PassportProject project={project}/>
      </Col>
      <Col span={8}>
        
      </Col>
    </Row>
  );
}